<template>
  <b-modal
    centered
    :ok-title="$t('common.gotIt')"
    ok-only
    hide-footer
    id="sign-language-modal"
    :title="$t('dashboard.signLanguageModal.title')"
  >
    <video width="100%" controls>
      <source src="https://www.kultursphaere.sh/videos/sign-language.mp4" type="video/mp4" :alt="$t('dashboard.signLanguageModal.videoAlt')">
      {{ $t("dashboard.signLanguageModal.noVideo") }}
    </video>
  </b-modal>
</template>

<script>
export default {
  name: 'SignLanguageModal'
}
</script>
